import { SIcon, SRow } from '@avalara/skylab-sdk/react';
import { Fragment, useState } from 'react';

import { BlueHeading, CheckItem, Slider } from '../shared/accordion-styled-components';
import { mrsText } from './constants';

const Accordion = () => {
  const { accordions, additionalParagraphContent } = mrsText;

  const [accordionState, setAccordionState] = useState(
    accordions.reduce<Record<number, boolean>>((ac, _, i) => {
      ac[i] = false;
      return ac;
    }, {}),
  );

  const toggleAccordion = (i: number) =>
    setAccordionState({
      ...accordionState,
      [i]: !accordionState[i],
    });

  return (
    <div data-ref='buy.returns.accordion-container' className='pad-top-md'>
      <hr className='pad-bottom-sm' />
      {accordions.map(({ accordionHeading, accordionSections }, i) => (
        <Fragment key={accordionHeading}>
          <span className='flex align-items-center pad-bottom-sm'>
            <button
              type='button'
              data-ref={`buy.returns.accordion-${i}.toggle-button`}
              className='tertiary'
              onClick={() => toggleAccordion(i)}
            >
              <SIcon
                className='text-md'
                name={accordionState[i] ? 'chevron-up' : 'chevron-down'}
                aria-label={accordionState[i] ? 'Collapse accordion' : 'Expand accordion'}
                role='button'
              />
            </button>
            <div className='flex flex-dir-col'>
              <BlueHeading className='font-bold pad-left-sm'>{accordionHeading}</BlueHeading>
            </div>
          </span>
          <Slider show={accordionState[i]}>
            {accordionSections.map(({ infoHeading, infoBullets, finePrint }) => (
              <div key={infoHeading} className='margin-bottom-lg'>
                {infoHeading && <h3 data-ref='buy.returns.accordion.info-heading'>{infoHeading}</h3>}
                {infoBullets.map((infoBullet) => (
                  <CheckItem key={infoBullet} leftPadSize={30}>
                    <SIcon name='check' />
                    <h3 data-ref='buy.returns.accordion.info-bullet' className='margin-left-sm font-normal'>
                      {infoBullet}
                    </h3>
                  </CheckItem>
                ))}
                {finePrint && (
                  <SRow>
                    <p className='text-sm pad-top-xs pad-left-lg pad-right-lg pad-bottom-xs'>{finePrint}</p>
                  </SRow>
                )}
              </div>
            ))}
            {additionalParagraphContent.map((paragraphText) => (
              <p key={paragraphText} className='text-md font-normal pad-all-sm pad-left-xl margin-left-xl'>
                {paragraphText}
              </p>
            ))}
          </Slider>
          <hr className='pad-bottom-sm' />
        </Fragment>
      ))}
    </div>
  );
};

export default Accordion;
